import React from 'react';
import {
  Breadcrumb,
  Container,
} from "react-bootstrap";


export default function Index({children}) {

  return (
    <Container fluid>
      <Breadcrumb>
        <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
          Audits
        </Breadcrumb.Item>
        <Breadcrumb.Item aria-current="page" active>
          Index
        </Breadcrumb.Item>
      </Breadcrumb>
      {children}
    </Container>
  );
}

